import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz15 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel16'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel14'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Camel and Banana Puzzle</h1>
    
    
    <div class="text">
        <p>A person has 3000 bananas and a camel. The person wants to transport the maximum number of bananas to a
            destination which is 1000 KMs away, using only the camel as a mode of transportation. The camel cannot carry
            more than 1000 bananas at a time and eats a banana every km it travels. What is the maximum number of
            bananas that can be transferred to the destination using only camel (no other mode of transportation is
            allowed).&nbsp;</p>
            <div class="containers">
        <p><strong>Solution:</strong>&nbsp;<br/>
            Let’s see what we can infer from the question:</p>
        <ul>
            <li>We have a total of 3000 bananas.</li>
            <li>The destination is 1000KMs</li>
            <li>Only 1 mode of transport.</li>
            <li>Camel can carry a maximum of 1000 banana at a time.</li>
            <li>Camel eats a banana every km it travels.</li>
        </ul>
            </div>
        <p>With all these points, we can say that person won’t we able to transfer any banana to the destination as the
            camel is going to eat all the banana on its way to the destination.</p>
        <p>But the trick here is to have intermediate drop points, then, the camel can make several short trips in
            between.&nbsp;</p>
        <p>Also, we try to maintain the number of bananas at each point to be multiple of 1000.</p><br/>
        
        <div id="AP_G4GR_5"></div>
        
        <p>Let’s have 2 drop points in between the source and destination.</p>
        <p>With 3000 bananas at the source. 2000 at a first intermediate point and 1000 at 2nd intermediate point.</p>
        <p><strong>Source</strong>————–<strong>IP1</strong>—————–<strong>IP2</strong>———————-<strong>Destination</strong>
        </p>
        <p>3000 &nbsp; &nbsp; &nbsp;<strong> x km&nbsp;</strong> &nbsp; &nbsp; &nbsp; 2000 &nbsp; &nbsp;&nbsp;<strong>y
                km</strong> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 1000 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>z
                km</strong></p>
        <p>——————–&gt; &nbsp;| &nbsp; &nbsp;—————&gt; | ———————–&gt;</p>
        <p>&lt;——————- &nbsp; &nbsp;| &nbsp; &nbsp;&lt;————– &nbsp;|</p>
        <p>——————-&gt; &nbsp; &nbsp;| &nbsp; &nbsp;—————&gt; |</p>
        <p>&lt;—————— &nbsp; &nbsp; &nbsp;| &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; |</p><br/>        
        <p>——————-&gt; &nbsp; &nbsp; | &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; |</p>
        <ul>
            <li>To go from source to IP1 point camel has to take a total of 5 trips 3 forward and 2 backward. Since we
                have 3000 bananas to transport.</li>
            <li>The same way from IP1 to IP2 camel has to take a total of 3 trips, 2 forward and 1 backward. Since we
                have 2000 bananas to transport.</li>
            <li>At last from IP2 to a destination only 1 forward move.</li>
        </ul>
        <p>Let’s see the total number of bananas consumed at every point.</p>
        <ul>
            <li>From the <strong>source to IP1</strong> its 5x bananas, as the distance between the source and IP1 is x
                km and the camel had 5 trips.</li>
            <li>From <strong>IP1 to IP2</strong> its 3y bananas, as the distance between IP1 and IP2 is y km and the
                camel had 3 trips.</li>
            <li>From <strong>IP2 to destination</strong> its z bananas.</li>
        </ul>
        <p>We now try to calculate the distance between the points:</p>
        <ol>
            <li><strong>3000 – 5x = 2000</strong> so we get <strong>x = 200</strong></li>
            <li><strong>2000-3y = 1000</strong> so we get <strong>y = 333.33</strong> but here the distance is also the
                number of bananas and it cannot be fraction so we take y =333 and at<strong> IP2</strong> we have the
                number of bananas equal <strong>1001, </strong>so its<strong> 2000-3y = 1001</strong></li>
            <li><strong>So </strong>the remaining distance to the market is<strong> 1000 -x-y =z </strong>i.e<strong>
                    &nbsp;1000-200-333 =&gt; z =467.</strong></li>
        </ol>
        <p>So from <strong>IP2 to the destination</strong> point camel eats <strong>467 bananas. </strong>The
            remaining<strong> bananas are 533.</strong><br/>
            &nbsp;</p>
        <p><strong>So </strong>the <strong>maximum number of bananas that can be transferred is 533.</strong></p>
        <p><strong>Another Approach:</strong></p>
        <p>If the camel doesn’t eat a banana while returning, which means when it doesn’t have a banana, then the
            maximum number of bananas that can be transferred will be 833.</p>
        <p>Let us divide the journey into 3 parts. First, the camel takes 1000 bananas and travels 333 KMs and puts the
            remaining bananas (1000-333 = 667) at first intermediate place and returns back to the source. Similarly,
            two more times, the camel takes 1000 bananas and travel for 333 KMs and put there remaining. Now, the total
            numbers of bananas are 2001 at the first intermediate place.&nbsp;</p>
        <p>Again, the camel takes 1000 bananas and travels 500 KMs and puts the remaining bananas(1000-500=500) at
            second intermediate place and returns back to first intermediate place. Similarly one more times, the camel
            takes 1000 bananas and travels for 500 KMs and put there remaining bananas. Now, the total number of bananas
            is 1000 at the second intermediate place.&nbsp;</p>
        <p>At last, the camel takes 1000 bananas and travels the remaining journey to 167 KMs. Thus, the total number of
            bananas is 833 at the final destination.</p>
        <p>So, the maximum number of bananas can be transferred is 833, if the camel doesn’t eat a banana while
            returning.</p>
        
    </div>
</article>
        </div>
    )
}

export default Puz15
